import { render } from "./ReportOrders.vue?vue&type=template&id=3c04d783&scoped=true"
import script from "./ReportOrders.vue?vue&type=script&lang=js"
export * from "./ReportOrders.vue?vue&type=script&lang=js"

import "./ReportOrders.vue?vue&type=style&index=0&id=3c04d783&lang=css"
import "./ReportOrders.vue?vue&type=style&index=1&id=3c04d783&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c04d783"]])

export default __exports__